module.exports = __webpack_public_path__ + "d1df5d55fef8f1dea2c2877992be3ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_200.jpg
// module id = 1702
// module chunks = 5